var _image, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 149",
    enableBackground: "new 0 0 260 149",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 260,
    height: 149,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQQAAACVCAYAAAC+RYRYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ bWFnZVJlYWR5ccllPAAAEWRJREFUeNrsnf91m0gQx9G9+/+4CkIqOLkC4wqiVGBcgZUKjCuQUoGU CixXgFKBlApEKpCuAh1znk3G411YEJIF+n7e42GLZWEXZpiZ/RUEAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQcwaogvNgv9+P+c/F YDDIW8ozKnaR9cEPBkvUOoBCOF+FsC12OQvwrthIYL8UgrvzPD8udrT9w3kM+ZBN8ENxfM3X/UFp oSgAOA+F8FRsCf89LLas2NKKcxI+j1gV24R/i2tcN+ZzJpzHnq89ZgsDAPAOCiEttpn4n5TCtthC lS6kdHxs1bbgcv5S0TzVUTAALgNoRxBJ6CaFyX4lfsuK3ffit1TFBciSmMtYA59PbsAH4Q4M2T0I lPuwYxeB3IW1K2bByoiudc8/kQuzwNOCQgCHC/yY/fufJJCFYE0tafbF7m8TN2Ahfyq2jzqWwMI6 KrZPvM9Z4H+yoFP63Ag7pzeKIuLtmn8zMYtnjiPsbO5JsXvg69y1FfgE4FIVwopN/ZTN/ciShnz3 keW3VPn8M2HOJ4e6DOyejPket5z/0OFOpHztMZ4qAM2FbmaEiP+eOeIIE+1KFNvGuAsstOmxAn58 jQkrhswWP2AFsuFyhHi6ANQXtP8DdULobAHDEQm8EryIBTM58f2GwpqZOYKbK96gFABoYJZvtCtg Whf4/82+HON2JCdWDE+sGEYOy+eVUjDKBE8dgHLh2iuLIRNxhdjmt1ssiFT4+qdUDAlfc1ymFPge t7KsNa8zdsUwAOitQmh4vgnozViBbE/ZR0D0jbDFP4yFs+UYRNbAEslEB6vtqd0kALqmEBLZ6sCC k564DEObpSBiDpEtOFqRZ6xjFcLSmCBGAS4hhjCu22woLISJ+Con71QW5xecyzX2yCcSvS4Tx3Fj ecBaAL1SCL+6JvPX1Hz9TMBuw3+beELsEBATiNzIFol3KM+YB2TZjq3KXBlWKDPh/oQeltGG801g MYA+KISVidKzQGcOIVlVtDiYlobROyu3vctdsblG7AI8iTjDrG5fClYGcgBWCuUAuqgMIvM1FdbB sExpWMzz6EzKYgQydZQh1paLjDu00XrA9WkUzBPeMNA1hZCInn9PwnUY2pSGOjc7pzZ9FviU72sr vtYTFviJFlI+J/Ooo0xYQhvOK6q4lwxvGOiaQgj55R2x0Jj/t8onn9l8546ULRUuT+IruKK5cSMD rGLMRlnwcgSFAPqiJDYyEq/dBeFaxH1ymRwWkDOwyEK/dwRZazVvAnCOX9OR/vLbBKZJ554zL/ve Mh7CtB64lMGM04xtlpLp5Yk3C3RVKGQzY+xyFzgIt+/TFGa2kZNy2jiHsBsiWyC2qnkTgHMXCmu3 XjGk2fTj3/Tty8flnljqI9IdnZQySGzKg62tPd4q0FWBGLGgbyxBt5WaQCXuafl1c+ReKIu9aLF4 pQxs7oFplcCbBboqEDPTMefCLaShUoQji1WwdyjNWLkbmLUJdFoYVpccFdczRbFlMLPEDbQyeDUD NbsZe/RSBF0VBPNCby95nL8Q5EjEAbbKNdCBQzMzU+pSLAB0TRDGJn6AunhjJYxc4yJMN2iVPupb Cwy4PCEwQbMZ6uJXE2KsLKhMdO/OxKxQqTo/Q98D0HUhyDADkNViCi2u1ci1HJ3rPAC6JgBmEBDm CfxdJ7VGKrL7gDoEvXj59+hE86ZOQh0fKEk7hIV1GrCU24kUQvCyhuLVgfmQGR17Jqdl3ObnrhSK XcZ1c+dSBpzmy7mXpw/8gSo4GbsW8iBlcC3+v1abgRZ8va0hmKlwa1yzNI3b9t15DcmbYjNBxTeD n4rdCsoA9NFlyFrIJ1Xt8anclL+deeaZlMzgtBcjNM2cBcMj1I9c4n6kFoeJ8QbBQgD+fOCtKQ/8 BV67vuK0BHyx0Zf8K5nvbSsFvga5DLRRT84tW1S06vUSj/h0/Ikq6DS5cBW+N8wj8jXHaQn7Qhns WCl8dCwbT5ZJXBwbNFAMi2K3wGOFQgDNvqwkyPNTX7MQ+k/GssBTgEIAzb7kfYIUAQUav0lXQ61d WdnM2sSKAIgh9EUh9KZ3XSHHOccTZjYh9wGvBBTCJUNf0V71sCtkOiUlV2dOAnTOgssAXvjBAhHx 17VKcKJil1gOXfPxtCILanWIHOmWVZF7avazBQwtUKsANQ/OfdLDMoCFAFgIee9rJZBCuFUCfsuu R6TSPvCxD+r8PHjbYYn+jssUAc/+vPVZKo4VC7UKTKQVICdH1b+VXHu1rwYzJIF+YFYi8kz7qmOR +d/W4UjMQxiL31wdllLLcOK9us5KnLv3uFfr+hHc0Wjs4z6YCVNLpmMPMQcCLIQ+WgnxAeeHNeMQ TTss1epiza7CY/A2wPgc+HefHrErs6s4nuM1gkLoC9+Clz77UUMhpY3a/9ce6Y1rYVyHQyybSthl iJSiWNQo7zUrEBefuP7AkUFQ8USQv10IR85fu2nNc0kJ3NRIPw+adVjaCSvke50goMO9IKWwcXke 6pwrR5qI6+wObxEUQt+gtvv7ugrhhEprXQjgF/7aT1vI73MLt0XKYOHZ6gHgMnQK+mqH5zyCj6wL 6mNwRgJ4W+FOAFgInXUbdoUyMFbCsstl4RYBCiQeuwfmDnMhQCH0mamnEEU1Zxe+9bA8KHj3vaVy jLkcj/x/rBQGHV/qYdWsSOjYVFshPKyaRkpOhRK9wSsDLor9O9PwnmM9y5I4NhMrVYVSGfDEJ3tO I49FonPSTF0rwlsCC+HS3ImBQ/BIGEbCqlhzk15ryqjienlgCepxL8W/lVIbsztEaanVgHpRUiuD uV/KlyyGj+xurPhYyMfINTDdoVccO/iHjhX/X7kmcQEtvoeogvOwEGwKgQWMhMoITS5M85s2An/y 2jyH4YTjG3nwuzNUxNdbu6wFEuLgZVh0LsdKGDeA/12q4dJDVgQ7Vjq5ODbia1sVEgC9VgglJnkq 1oXci1WkszavLVdUEgvL7LnL9cy1DJ2YkzHBkwTguDGEV6shy7UMjhROmFnWUkzNupQlMzKP8BQB OL6iSG0BNh6ReIzrDW15szKI8UT6DzomnT823zk88fXgvwPwDi6Cbr4b6jUTTAyhSb4+zY5sDSSW GEF4yDXes4kUgD4pj0TMebDRbfvHchv4Oia4iBjBhYBmx24ohSjg4cWnWLiEFY6xStZo8gMAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA78XJJkjxXJaM5vSfV6S1zeEfFbvE I/8lL8tOaSN5Tcv9mjUDruX9FduPYpubSUN48tH4V4UOBqklrzdpai7TtiybGEXnX8LcUm+mjL8W ggleloJfWK5TVc95INZQsKR/Uw5RD0u1noNZ8s3nXOdz9KyfN4vfVJyzDBwTx9R5Frz3rs9e4Tll XlYj7ZOY5y/2PCfl9Jm+plQEYkmxMkbmpaya88+WpuZUgmmVsvXMJzbCVmyTirRvZlquW898jlzu 7UnlNyp5DiNbfZcc37qmlvOsn1dTxXmeM9PXrPMsmtTnsenyrMv08GYtKy2yCujFHHokH3ZUMYdc xnFFUvq6Zw0XYHngVafM19Sgv5zXJcc+Wb7Kklv1v1kOril0/pOc0NYDqptNzXOCA+vzqLzX2o70 cL87TKSytH/xQzBaeeR4GGSO/XTkVSUo+iuzYDfBXD9uSRk86odeUj/LA/OW9ftguf8duwqh5RhZ Ekvpajjq+YMyf+k6Uy6HEVSyTGJh+r+xQBzHltJsFq5OYFES85r1c62uRff9ueScv/jakVIkVw7T vuxZRA3qs5cuQ9o0rcVUTCymV1yRf2ZxU8aWFYkilyVxqMtwSP00yd8IksUcHVvSaJdp5nAZtEBr NySyXDMtuZdU1G/ZOyDLm+lr1q0fVd6N5zlPtnr0fRZN6xMugz2oqE3bNtAm6mfHV5GCgs4VmIVv +GtjbX8OaPP/sSjHVJWNynyjrDVft+Ff/Ww4v9xSzzalfe04tihxF74pq+D+wHfK9326U+fdHuF5 /Xukd/3sFMJDkwU4WEPee7gBmS1YWYE2UXMl5KneHPlkli05ZeWWBKWuVdKpQ+HtWNBeKTqP+Mut ymdpeUZDds+uLa5ibDm2UytGS3N9xy0Lzw2Ul8wvruuecR2tq2JKTQOEFfXZuxhCXeXx4NLs3IwY H/keYuXjG9Kgw1Q0Z/k0dWUlulx+1Z+VoEohzDntWNT1yDOYuOByLIr72LE/T3GKxNUEaYS0pEzP Naowb/mR+NZn7xRC3kJl7thss7FWL/T6hGWzafHoFOZeyT00qevwwOf7peR+7kV9LFgIxyJ4ZhVQ SzDxh/gYLMUx3+Dim3rTLlQF0Ymeha7Piw4quoh8gzOeQcVGwamOBRXTsrb9kkDb3lHPruXhw4o6 t/Xn2Ho8Z982/ibnzWoGIkN1z6sWgore9XnJQUUKfFGPys8lPn8baFPx6ZQP4kTor+bM1mzLwjEs Oc9ww89mqnxpW719r/iC2iyrtQrs1gnc3Ze4SgO+7/UB79NElfO5hedTpz4vNoYQCD8xF2bafcmL euuwEsq6AM/ZXA3Fg6BOJ2TS/mzwQp5jHeZFeabCPKeyrriM1NdCt7Eb1+yxIuuvweuOTvcWE3dh cQdk/4Ln4G3fgqUK/kXqeem+JrJPQeJhZtN9G8uAmkFHJa1Hxmpz1dG04rwq5Vy3Pi/WZUjF74mj K24rXZfFysfeS5N3yWUQpu6qhumd+Lhm3I23tBuxpW7HMj7gcif4+JPuK2DJf2i797L64S7atnfB 1z3ZSivrwK7LterzUl0G+YWbq6DMQ8v5kwl54xmEnHdRMfMX+Sao7vWWswnrW85HFZAcewTYltJ6 0fVuvtaWYOKi5PnVdTHkfcc1W6yobq5ks2ibrrJHfXbaZXgseTHqpL2T/h5rztzDrJV5fRM+bW55 qa7EqDXbaEc52nJZ47pt1U+T/LVS+FKU8WtQY7SjpZ5z5Y7cCVN65zCFf6i61nUwtDyXUF23TEnZ 3o9l2UdGBZBDjzpdBo7RjjWeRW557nXrEwAAAAAAAAAAAAAAAAAAAAAAAAAAAADOnwGq4HiYMQm2 tRqapBVrReQVE4DEQfN1CH4NABPrV8xd08m57r/GeAy9FofzWnKdB586BeDcFEKd6eF8BibNfCbc 9Bxg82qcvTgnFb9lPvNL2O6/xuCpTF1/5lF+KIMj8QeqoDPKJQxeT0OWeJz2OBAU//8d/B68RdbG w7Hud6AIfvfxf1SHbvh3GmxFlkFiU0D8W8JppngjoBAuHaMAzGCY2wZCumN3wORxNovN8EAhc182 RTXh/ZdeLm0GhQBqYmYAmvMWlU2BVsFZChTHRUhhxWoehoSV19I1gQmAQrgkd4HMZYoZmGHXz02t BGUZ5GdYXDMz0IQncwmldYC34bj8iSroBEbwv/GX1EwnR6tYRSUtANeWAJxZIsxnarT3sBLWxT3P +R5pUhCasoyUwvRIE5EAcLIv+8GtDPyVfDNtmK1VwHLMa/VsV36HtDJYjme+LQSWGY23PZzwFi4D aITxpbXvPPdwGx4t0f4bPpfiD9k5FlgFGP93FRBIhMsAXjDBxNDydSVXoXS2YIuwLYudWe1qqFZc PielMKXFTvnvOV4DKAS4HL+DidJScMUY6kbf8+C0q0kBuAzgQIw7cDewELx0NCJTetTAx4YyAFAI HbIOwpL4gfS1Fx4WhMx3yN2DSSHk5+guACiEvgt36YIdjtOMgM8rAmpfVaxB8mBZXGYV/O4C/Nmz CFnV4jcAMQRQjU87f+5IayLtpbEBbrenDjv/d+Jh5bH0uOZCKZql2hNy/QoXS8+ymryWLdcfAAAA AAAAAAAAAAAAAAAAAAAAAAA4Q/4TYADJUT29pGiK5QAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 -333.8023 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M-192.8,72c0.2,0,0.3,0,0.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0.9953,4.9764",
    d: " M-187.3,72.6c13.3,1.7,22.2,4.8,22.2,8.4c0,5.4-19.9,9.7-44.4,9.7s-44.4-4.3-44.4-9.7c0-3.9,10.4-7.2,25.5-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M-226,71.9c0.2,0,0.3,0,0.5,0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M-200.1,74.7c7.3,0.8,12.3,2.6,12.3,4.6 c0,2.8-9.7,5.1-21.7,5.1s-21.7-2.3-21.7-5.1c0-2.1,5.3-3.9,12.9-4.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-192.5,44.7c-6.6-0.8-13-5.8-15.7-8.1c-0.7-0.6-1.9-0.6-2.6,0 c-2.7,2.3-9,7.3-15.7,8.1c-1.1,0.1-1.8,1-1.8,2.1c0.8,20.1,14.1,29,17.8,31.1c0.6,0.3,1.3,0.3,1.9,0c3.7-2.1,17-10.9,17.8-31.1 C-190.7,45.7-191.5,44.8-192.5,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-194.9,46.4c-5.7-0.7-11.2-5-13.5-7c-0.6-0.6-1.6-0.6-2.2,0 c-2.3,2-7.8,6.3-13.5,7c-0.9,0.1-1.6,0.9-1.5,1.8c0.7,17.4,12.1,25,15.3,26.8c0.5,0.3,1.2,0.3,1.7,0c3.2-1.8,14.6-9.4,15.3-26.8 C-193.3,47.3-194,46.5-194.9,46.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9247 -0.3807 0.3807 0.9247 -37.5214 -75.4542)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    cx: -209.5,
    cy: 57.1,
    rx: 8.6,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-205.1,52.1 -211,58 -213.9,55.1 -216,57.2 -213.1,60.1 -211,62.2 -209,60.1 -203,54.2  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-253.3,102.3h5c1.5,0,2.9,0.3,4,0.8c1.1,0.6,2,1.4,2.6,2.4c0.6,1,0.9,2.3,0.9,3.7c0,2.3-0.7,4.1-2,5.3 c-1.4,1.2-3.2,1.8-5.7,1.8h-4.9V102.3z M-248.1,113.3c1.2,0,2.1-0.4,2.8-1.1c0.6-0.7,1-1.7,1-3c0-1.1-0.3-2.1-1-2.8 s-1.5-1.1-2.7-1.1h-1.8v8H-248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-239.3,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v2.6h6.4v3h-9.9V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-227.9,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v5.6h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-213.9,102.3h3.5l5.6,14h-3.6l-1.1-2.9h-5.2l-1.1,2.9h-3.6L-213.9,102.3z M-210.5,110.7l-1.7-4.7 l-1.7,4.7H-210.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-203.3,114.9c-1.1-1.1-1.6-2.6-1.6-4.5v-8.1h3.5v8.2c0,0.9,0.3,1.6,0.8,2.1c0.5,0.5,1.2,0.7,2.1,0.7 s1.6-0.2,2.1-0.7c0.5-0.5,0.7-1.2,0.7-2.1v-8.2h3.5v8.1c0,1.9-0.5,3.4-1.6,4.5c-1.1,1.1-2.6,1.7-4.8,1.7 S-202.2,116.1-203.3,114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-190.5,102.3h3.5v11h6.1v3h-9.6V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-178.7,105.3h-3.9v-3h11.4v3h-4v11h-3.5V105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-318.3,126.3h2.1v14h-2.1V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-313.6,126.3h1.9l7.1,10.5v-10.5h2.1v14h-2l-7.1-10.5v10.5h-2V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-298.4,140.4c-0.8-0.1-1.4-0.3-1.9-0.6V138c1.3,0.6,2.7,0.9,4.1,0.9c2.1,0,3.1-0.7,3.1-2.1 c0-0.5-0.1-0.9-0.3-1.2c-0.2-0.3-0.6-0.5-1-0.8c-0.4-0.2-1.1-0.5-2.1-0.9c-1.3-0.5-2.3-1.1-2.9-1.8c-0.6-0.6-0.9-1.4-0.9-2.4 c0-0.7,0.2-1.4,0.6-1.9c0.4-0.6,1-1,1.7-1.3c0.7-0.3,1.5-0.5,2.5-0.5c0.8,0,1.4,0.1,2.1,0.2s1.2,0.3,1.8,0.6v1.8 c-1.2-0.5-2.3-0.8-3.5-0.8c-1,0-1.7,0.2-2.2,0.5s-0.8,0.8-0.8,1.5c0,0.4,0.1,0.8,0.3,1.1c0.2,0.3,0.5,0.6,1,0.8 c0.4,0.2,1.1,0.5,1.9,0.9c0.9,0.4,1.7,0.8,2.2,1.1s1,0.8,1.3,1.3s0.4,1.1,0.4,1.9c0,1.2-0.4,2.2-1.3,2.8c-0.9,0.7-2.1,1-3.8,1 C-296.8,140.6-297.6,140.6-298.4,140.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-287.3,139.2c-1-1-1.5-2.3-1.5-4.1v-8.8h2v8.8c0,1.2,0.3,2.1,1,2.7c0.7,0.6,1.6,0.9,2.7,0.9 c1.1,0,2.1-0.3,2.7-0.9c0.7-0.6,1-1.5,1-2.7v-8.8h2v8.8c0,1.7-0.5,3.1-1.5,4c-1,1-2.4,1.5-4.3,1.5 C-284.9,140.6-286.4,140.1-287.3,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-274.8,126.3h5.6c1.5,0,2.6,0.4,3.4,1.1c0.8,0.7,1.2,1.8,1.2,3.2c0,1-0.3,1.9-0.8,2.6 c-0.5,0.7-1.3,1.2-2.3,1.5l3.1,5.7h-2.1l-3-5.5h-3.1v5.5h-2V126.3z M-269.5,133.1c0.9,0,1.6-0.2,2.1-0.6s0.8-1,0.8-1.9 c0-0.9-0.3-1.6-0.8-1.9c-0.5-0.4-1.2-0.6-2.2-0.6h-3.2v5H-269.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-258,126.3h2l5.6,14h-2.1l-1.4-3.5h-6.2l-1.4,3.5h-2.1L-258,126.3z M-254.5,135.1l-2.5-6.5l-2.5,6.5 H-254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-248.3,126.3h1.9l7.1,10.5v-10.5h2.1v14h-2l-7.1-10.5v10.5h-2V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-231.4,139.7c-1.1-0.6-2-1.5-2.6-2.5s-0.9-2.4-0.9-3.8s0.3-2.7,0.9-3.8s1.5-2,2.6-2.6 c1.1-0.6,2.4-0.9,3.8-0.9c1.9,0,3.5,0.5,4.8,1.5v2c-1.2-1-2.7-1.5-4.6-1.5c-1.1,0-2,0.2-2.9,0.7c-0.8,0.4-1.5,1.1-2,1.9 c-0.5,0.8-0.7,1.8-0.7,2.9s0.2,2.1,0.7,2.9c0.5,0.8,1.1,1.5,2,1.9c0.8,0.4,1.8,0.7,2.9,0.7c1,0,1.9-0.1,2.6-0.4 c0.8-0.3,1.5-0.7,2.2-1.3v2c-1.2,1-2.9,1.5-5,1.5C-229,140.6-230.3,140.3-231.4,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-220.4,126.3h9.2v1.7h-7.2v4.4h5.4v1.7h-5.4v4.4h7.2v1.7h-9.2V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-201.6,126.3h5.4c1.5,0,2.7,0.4,3.6,1.1s1.3,1.8,1.3,3.2c0,1.4-0.4,2.5-1.3,3.2 c-0.9,0.7-2.1,1.1-3.6,1.1h-3.3v5.3h-2V126.3z M-196.5,133.3c0.9,0,1.7-0.2,2.2-0.6c0.5-0.4,0.8-1.1,0.8-2s-0.3-1.6-0.8-2 c-0.5-0.4-1.3-0.6-2.2-0.6h-3.1v5.2H-196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-189.6,126.3h5.6c1.5,0,2.6,0.4,3.4,1.1c0.8,0.7,1.2,1.8,1.2,3.2c0,1-0.3,1.9-0.8,2.6 c-0.5,0.7-1.3,1.2-2.3,1.5l3.1,5.7h-2.1l-3-5.5h-3.1v5.5h-2V126.3z M-184.3,133.1c0.9,0,1.6-0.2,2.1-0.6s0.8-1,0.8-1.9 c0-0.9-0.3-1.6-0.8-1.9c-0.5-0.4-1.2-0.6-2.2-0.6h-3.2v5H-184.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-174.2,139.7c-1.1-0.6-2-1.5-2.6-2.6c-0.6-1.1-1-2.4-1-3.8s0.3-2.7,1-3.8c0.6-1.1,1.5-2,2.6-2.6 s2.4-0.9,3.8-0.9s2.6,0.3,3.8,0.9s2,1.5,2.6,2.6c0.6,1.1,1,2.4,1,3.8s-0.3,2.7-1,3.8c-0.6,1.1-1.5,2-2.6,2.6s-2.4,0.9-3.8,0.9 S-173.1,140.3-174.2,139.7z M-167.8,138.1c0.8-0.4,1.4-1.1,1.9-1.9c0.5-0.8,0.7-1.8,0.7-2.9c0-1.1-0.2-2-0.7-2.8 s-1.1-1.5-1.9-1.9s-1.7-0.7-2.7-0.7c-1,0-1.9,0.2-2.7,0.7c-0.8,0.4-1.4,1.1-1.9,1.9c-0.5,0.8-0.7,1.8-0.7,2.9 c0,1.1,0.2,2,0.7,2.9c0.5,0.8,1.1,1.5,1.9,1.9c0.8,0.4,1.7,0.7,2.7,0.7C-169.5,138.8-168.6,138.6-167.8,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-158,139.7c-1.1-0.6-2-1.5-2.6-2.5s-0.9-2.4-0.9-3.8s0.3-2.7,0.9-3.8s1.5-2,2.6-2.6 c1.1-0.6,2.4-0.9,3.8-0.9c1.9,0,3.5,0.5,4.8,1.4v2c-1.2-1-2.7-1.5-4.6-1.5c-1.1,0-2,0.2-2.8,0.7c-0.8,0.4-1.5,1.1-2,1.9 c-0.5,0.8-0.7,1.8-0.7,2.9s0.2,2.1,0.7,2.9s1.1,1.5,1.9,1.9c0.8,0.4,1.8,0.7,2.8,0.7c1.2,0,2.2-0.2,3-0.7v-3.7h-2.7v-1.7h4.7v6.4 c-0.6,0.5-1.4,0.9-2.2,1.1s-1.8,0.4-2.9,0.4C-155.6,140.6-156.9,140.3-158,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-146.9,126.3h5.6c1.5,0,2.6,0.4,3.4,1.1c0.8,0.7,1.2,1.8,1.2,3.2c0,1-0.3,1.9-0.8,2.6 c-0.5,0.7-1.3,1.2-2.3,1.5l3.1,5.7h-2.1l-3-5.5h-3.1v5.5h-2V126.3z M-141.6,133.1c0.9,0,1.6-0.2,2.1-0.6c0.5-0.4,0.8-1,0.8-1.9 c0-0.9-0.3-1.6-0.8-1.9c-0.5-0.4-1.2-0.6-2.1-0.6h-3.2v5H-141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-130.1,126.3h2l5.6,14h-2.1l-1.4-3.5h-6.2l-1.4,3.5h-2.1L-130.1,126.3z M-126.6,135.1l-2.5-6.5l-2.5,6.5 H-126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-120.9,126.3h2l5,10.9l5-10.9h2v14h-2v-9.9l-4.5,9.9h-1l-4.6-9.9v9.9h-2V126.3z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.4,115.7c-1.2-0.6-2-1.4-2.7-2.5s-0.9-2.4-0.9-3.9s0.3-2.8,0.9-3.9s1.5-1.9,2.7-2.5 c1.2-0.6,2.5-0.9,4-0.9c1,0,1.9,0.1,2.7,0.3c0.8,0.2,1.5,0.5,2.2,0.9v3.4c-0.6-0.5-1.3-0.8-2-1c-0.7-0.2-1.6-0.3-2.6-0.3 c-1.4,0-2.4,0.4-3.2,1.1c-0.7,0.7-1.1,1.7-1.1,3c0,1.3,0.4,2.3,1.1,3c0.8,0.7,1.8,1.1,3.2,1.1c1,0,1.8-0.1,2.6-0.3 s1.5-0.6,2.1-1.1v3.3c-1.3,0.9-2.9,1.3-5,1.3C34.9,116.6,33.5,116.3,32.4,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.6,115.7c-1.1-0.6-2-1.5-2.7-2.6s-1-2.4-1-3.8s0.3-2.7,1-3.8s1.6-2,2.7-2.6c1.1-0.6,2.4-0.9,3.8-0.9 c1.4,0,2.7,0.3,3.8,0.9c1.1,0.6,2,1.5,2.7,2.6s1,2.4,1,3.8s-0.3,2.7-1,3.8s-1.5,2-2.7,2.6c-1.1,0.6-2.4,0.9-3.8,0.9 C48,116.6,46.8,116.3,45.6,115.7z M51.4,112.8c0.6-0.3,1.1-0.8,1.4-1.4c0.3-0.6,0.5-1.3,0.5-2.1s-0.2-1.5-0.5-2.1 s-0.8-1.1-1.4-1.4c-0.6-0.3-1.2-0.5-2-0.5c-0.7,0-1.4,0.2-2,0.5c-0.6,0.3-1,0.8-1.4,1.4s-0.5,1.3-0.5,2.1s0.2,1.5,0.5,2.1 c0.3,0.6,0.8,1.1,1.4,1.4c0.6,0.3,1.3,0.5,2,0.5C50.1,113.3,50.8,113.1,51.4,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.3,102.3h3.5l5.1,8.3v-8.3h3.5v14H67l-5.2-8.3v8.3h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.5,105.3h-3.9v-3H83v3h-4v11h-3.5V105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.8,102.3h3.5l5.6,14h-3.6l-1.1-2.9H86l-1.1,2.9h-3.6L86.8,102.3z M90.3,110.7l-1.7-4.7l-1.7,4.7H90.3z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M97.3,102.3h3.5v14h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M102.6,102.3h3.5l5.1,8.3v-8.3h3.5v14h-3.5l-5.2-8.3v8.3h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M116.6,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v2.6h6.4v3h-9.9V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M127.9,102.3h6.3c1.6,0,2.9,0.4,3.8,1.2s1.4,2,1.4,3.6c0,1-0.2,1.9-0.7,2.7c-0.5,0.7-1.1,1.3-1.9,1.6 l2.5,4.9h-3.6l-2.2-4.4h-2v4.4h-3.5V102.3z M133.6,109c0.7,0,1.3-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.4c0-0.7-0.2-1.2-0.6-1.4 c-0.4-0.3-0.9-0.4-1.7-0.4h-2.1v3.6H133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M147.7,102.3h5c1.5,0,2.9,0.3,4,0.8s2,1.4,2.7,2.4s0.9,2.3,0.9,3.7c0,2.3-0.7,4.1-2,5.3 c-1.4,1.2-3.2,1.8-5.7,1.8h-4.9V102.3z M152.9,113.3c1.2,0,2.1-0.4,2.8-1.1c0.6-0.7,1-1.7,1-3c0-1.1-0.3-2.1-1-2.8 c-0.6-0.7-1.5-1.1-2.7-1.1h-1.8v8H152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M161.7,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v2.6h6.4v3h-9.9V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M173,102.3h6.2c1.6,0,2.9,0.4,3.9,1.3c1,0.9,1.5,2,1.5,3.6c0,1.6-0.5,2.8-1.5,3.7c-1,0.9-2.3,1.3-3.9,1.3 h-2.6v4.2H173V102.3z M178.6,109.2c0.7,0,1.3-0.1,1.7-0.4c0.4-0.3,0.6-0.8,0.6-1.5c0-0.7-0.2-1.2-0.6-1.5s-1-0.4-1.7-0.4h-2.1 v3.8H178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M188.7,115.7c-1.1-0.6-2-1.5-2.7-2.6c-0.7-1.1-1-2.4-1-3.8s0.3-2.7,1-3.8c0.7-1.1,1.6-2,2.7-2.6 c1.1-0.6,2.4-0.9,3.8-0.9c1.4,0,2.7,0.3,3.8,0.9c1.1,0.6,2,1.5,2.7,2.6s1,2.4,1,3.8s-0.3,2.7-1,3.8s-1.5,2-2.7,2.6 c-1.1,0.6-2.4,0.9-3.8,0.9C191.1,116.6,189.8,116.3,188.7,115.7z M194.5,112.8c0.6-0.3,1.1-0.8,1.4-1.4c0.3-0.6,0.5-1.3,0.5-2.1 s-0.2-1.5-0.5-2.1c-0.3-0.6-0.8-1.1-1.4-1.4c-0.6-0.3-1.2-0.5-2-0.5c-0.7,0-1.4,0.2-2,0.5c-0.6,0.3-1,0.8-1.4,1.4 c-0.3,0.6-0.5,1.3-0.5,2.1s0.2,1.5,0.5,2.1c0.3,0.6,0.8,1.1,1.4,1.4c0.6,0.3,1.3,0.5,2,0.5C193.2,113.3,193.9,113.1,194.5,112.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M202.7,116.4c-0.9-0.2-1.6-0.4-2.1-0.7v-3.2c0.7,0.4,1.5,0.7,2.3,0.8c0.8,0.2,1.5,0.3,2.2,0.3 c0.7,0,1.1-0.1,1.5-0.3c0.3-0.2,0.5-0.5,0.5-0.9c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.4-0.8-0.6s-0.9-0.4-1.6-0.7 c-1.3-0.5-2.2-1.2-2.8-1.8c-0.6-0.7-0.9-1.5-0.9-2.5c0-0.8,0.2-1.5,0.7-2.1c0.4-0.6,1.1-1.1,1.9-1.5c0.8-0.3,1.7-0.5,2.8-0.5 c0.9,0,1.6,0.1,2.3,0.2s1.3,0.3,1.9,0.6v3.1c-1.2-0.6-2.4-0.9-3.5-0.9c-0.6,0-1.1,0.1-1.5,0.3c-0.4,0.2-0.6,0.5-0.6,0.9 s0.2,0.7,0.6,0.9c0.4,0.2,1.1,0.6,2.1,1c0.9,0.4,1.7,0.8,2.2,1.1s0.9,0.8,1.2,1.3c0.2,0.5,0.4,1.1,0.4,1.9c0,1.3-0.5,2.3-1.4,3 c-0.9,0.7-2.3,1.1-4.2,1.1C204.4,116.6,203.5,116.5,202.7,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M212.3,102.3h3.5v14h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M220.9,105.3h-3.9v-3h11.4v3h-4v11h-3.5V105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.1,126.3h2.1v14h-2.1V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.8,126.3h1.9l7.1,10.5v-10.5h2.1v14h-2l-7.1-10.5v10.5h-2V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M95,140.4c-0.8-0.1-1.4-0.3-1.9-0.6V138c1.3,0.6,2.7,0.9,4.1,0.9c2.1,0,3.1-0.7,3.1-2.1 c0-0.5-0.1-0.9-0.3-1.2c-0.2-0.3-0.6-0.5-1-0.8c-0.4-0.2-1.1-0.5-2.1-0.9c-1.3-0.5-2.3-1.1-2.9-1.8c-0.6-0.6-0.9-1.4-0.9-2.4 c0-0.7,0.2-1.4,0.6-1.9c0.4-0.6,1-1,1.7-1.3c0.7-0.3,1.5-0.5,2.5-0.5c0.8,0,1.4,0.1,2.1,0.2s1.2,0.3,1.8,0.6v1.8 c-1.2-0.5-2.3-0.8-3.5-0.8c-1,0-1.7,0.2-2.2,0.5s-0.8,0.8-0.8,1.5c0,0.4,0.1,0.8,0.3,1.1c0.2,0.3,0.5,0.6,1,0.8 c0.4,0.2,1.1,0.5,1.9,0.9c0.9,0.4,1.7,0.8,2.2,1.1s1,0.8,1.3,1.3s0.4,1.1,0.4,1.9c0,1.2-0.4,2.2-1.3,2.8c-0.9,0.7-2.1,1-3.8,1 C96.6,140.6,95.8,140.6,95,140.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M106.1,139.2c-1-1-1.5-2.3-1.5-4.1v-8.8h2v8.8c0,1.2,0.3,2.1,1,2.7c0.7,0.6,1.6,0.9,2.7,0.9 c1.1,0,2.1-0.3,2.7-0.9c0.7-0.6,1-1.5,1-2.7v-8.8h2v8.8c0,1.7-0.5,3.1-1.5,4c-1,1-2.4,1.5-4.3,1.5 C108.5,140.6,107,140.1,106.1,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M118.6,126.3h5.6c1.5,0,2.6,0.4,3.4,1.1c0.8,0.7,1.2,1.8,1.2,3.2c0,1-0.3,1.9-0.8,2.6 c-0.5,0.7-1.3,1.2-2.3,1.5l3.1,5.7h-2.1l-3-5.5h-3.1v5.5h-2V126.3z M123.9,133.1c0.9,0,1.6-0.2,2.1-0.6s0.8-1,0.8-1.9 c0-0.9-0.3-1.6-0.8-1.9c-0.5-0.4-1.2-0.6-2.2-0.6h-3.2v5H123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M135.4,126.3h2l5.6,14h-2.1l-1.4-3.5h-6.2l-1.4,3.5h-2.1L135.4,126.3z M138.9,135.1l-2.5-6.5l-2.5,6.5 H138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.1,126.3h1.9l7.1,10.5v-10.5h2.1v14h-2l-7.1-10.5v10.5h-2V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M162,139.7c-1.1-0.6-2-1.5-2.6-2.5s-0.9-2.4-0.9-3.8s0.3-2.7,0.9-3.8s1.5-2,2.6-2.6 c1.1-0.6,2.4-0.9,3.8-0.9c1.9,0,3.5,0.5,4.8,1.5v2c-1.2-1-2.7-1.5-4.6-1.5c-1.1,0-2,0.2-2.9,0.7c-0.8,0.4-1.5,1.1-2,1.9 c-0.5,0.8-0.7,1.8-0.7,2.9s0.2,2.1,0.7,2.9c0.5,0.8,1.1,1.5,2,1.9c0.8,0.4,1.8,0.7,2.9,0.7c1,0,1.9-0.1,2.6-0.4 c0.8-0.3,1.5-0.7,2.2-1.3v2c-1.2,1-2.9,1.5-5,1.5C164.4,140.6,163.1,140.3,162,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M173,126.3h9.2v1.7h-7.2v4.4h5.4v1.7h-5.4v4.4h7.2v1.7H173V126.3z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.3,
    y: 58.7,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 41.5,
    height: 27.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "172.2,71.1 172.2,90.1 97.7,90.1 97.7,54.5 161.7,54.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "172.2,71.1 172.2,90.1 144.5,90.1 144.5,54.5 161.7,54.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "168.9,67.3 168.9,85.9 147.8,85.9 147.8,58.7 162.9,58.7  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 107.4,
    y1: 62.5,
    x2: 107.4,
    y2: 82.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 115.5,
    y1: 62.5,
    x2: 115.5,
    y2: 82.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 123.5,
    y1: 62.5,
    x2: 123.5,
    y2: 82.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 131.5,
    y1: 62.5,
    x2: 131.5,
    y2: 82.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 158.3,
    y1: 58.7,
    x2: 158.3,
    y2: 85.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M191.3,47.1c-4.9-0.6-9.7-4.3-11.7-6c-0.6-0.5-1.4-0.5-1.9,0 c-2,1.7-6.8,5.4-11.7,6c-0.8,0.1-1.4,0.8-1.3,1.6c0.6,15,10.5,21.7,13.3,23.2c0.5,0.3,1,0.3,1.5,0c2.8-1.6,12.7-8.2,13.3-23.2 C192.7,47.9,192.1,47.2,191.3,47.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    cx: 178.6,
    cy: 56.4,
    r: 7.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 52.1,
    fill: "#FFFFFF",
    width: 2.2,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 52.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 235.0233 -122.2705)",
    fill: "#FFFFFF",
    width: 2.2,
    height: 8.5
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-658.4,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v5.6h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-647.5,102.3h6.3c1.6,0,2.9,0.4,3.8,1.2s1.4,2,1.4,3.6c0,1-0.2,1.9-0.7,2.7c-0.5,0.7-1.1,1.3-1.9,1.6 l2.5,4.9h-3.6l-2.2-4.4h-2v4.4h-3.5V102.3z M-641.8,109c0.7,0,1.3-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.4c0-0.7-0.2-1.2-0.6-1.4 c-0.4-0.3-0.9-0.4-1.6-0.4h-2.1v3.6H-641.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-634.6,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v2.6h6.4v3h-9.9V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-623.2,102.3h3.5v14h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-614.7,115.7c-1.2-0.6-2-1.4-2.7-2.5c-0.6-1.1-0.9-2.4-0.9-3.9s0.3-2.8,0.9-3.9c0.6-1.1,1.5-1.9,2.7-2.5 c1.2-0.6,2.5-0.9,4-0.9c1,0,1.9,0.1,2.7,0.3c0.8,0.2,1.5,0.5,2.2,0.9v3.4c-0.6-0.5-1.3-0.8-2-1c-0.7-0.2-1.6-0.3-2.6-0.3 c-0.8,0-1.6,0.2-2.2,0.5c-0.6,0.3-1.2,0.8-1.5,1.4c-0.4,0.6-0.6,1.3-0.6,2.1c0,1.3,0.4,2.3,1.1,3c0.7,0.7,1.7,1.1,3,1.1 c0.7,0,1.3-0.1,1.8-0.4v-2.2h-2.1v-2.5h5.5v7c-1.4,0.9-3.2,1.3-5.3,1.3C-612.2,116.6-613.5,116.3-614.7,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-604,102.3h3.5v5.4h5.5v-5.4h3.5v14h-3.5v-5.6h-5.5v5.6h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-586.4,105.3h-3.9v-3h11.4v3h-4v11h-3.5V105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-571,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v5.6h-3.5V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-557.3,115.7c-1.1-0.6-2-1.5-2.7-2.6c-0.7-1.1-1-2.4-1-3.8s0.3-2.7,1-3.8c0.7-1.1,1.6-2,2.7-2.6 s2.4-0.9,3.8-0.9c1.4,0,2.7,0.3,3.8,0.9c1.1,0.6,2,1.5,2.7,2.6s1,2.4,1,3.8s-0.3,2.7-1,3.8s-1.5,2-2.7,2.6 c-1.1,0.6-2.4,0.9-3.8,0.9C-554.9,116.6-556.2,116.3-557.3,115.7z M-551.5,112.8c0.6-0.3,1.1-0.8,1.4-1.4 c0.3-0.6,0.5-1.3,0.5-2.1s-0.2-1.5-0.5-2.1c-0.3-0.6-0.8-1.1-1.4-1.4c-0.6-0.3-1.2-0.5-2-0.5c-0.7,0-1.4,0.2-2,0.5 c-0.6,0.3-1,0.8-1.4,1.4c-0.3,0.6-0.5,1.3-0.5,2.1s0.2,1.5,0.5,2.1c0.3,0.6,0.8,1.1,1.4,1.4c0.6,0.3,1.3,0.5,2,0.5 C-552.8,113.3-552.1,113.1-551.5,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-544.6,102.3h6.3c1.6,0,2.9,0.4,3.8,1.2s1.4,2,1.4,3.6c0,1-0.2,1.9-0.7,2.7c-0.5,0.7-1.1,1.3-1.9,1.6 l2.5,4.9h-3.6l-2.2-4.4h-2v4.4h-3.5V102.3z M-538.9,109c0.7,0,1.3-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.4c0-0.7-0.2-1.2-0.6-1.4 c-0.4-0.3-0.9-0.4-1.7-0.4h-2.1v3.6H-538.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-532.7,102.3h3.6l2.3,8.3l2.3-8.3h2.5l2.1,8.3l2.3-8.3h3.6l-3.9,14h-3.3l-2.3-8.1l-2.3,8.1h-3.3 L-532.7,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-509.3,102.3h3.5l5.6,14h-3.6l-1.1-2.9h-5.2l-1.1,2.9h-3.6L-509.3,102.3z M-505.9,110.7l-1.7-4.7 l-1.7,4.7H-505.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-498.9,102.3h6.3c1.6,0,2.9,0.4,3.8,1.2s1.4,2,1.4,3.6c0,1-0.2,1.9-0.7,2.7s-1.1,1.3-1.9,1.6l2.5,4.9 h-3.6l-2.2-4.4h-2v4.4h-3.5V102.3z M-493.2,109c0.7,0,1.3-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.4c0-0.7-0.2-1.2-0.6-1.4 c-0.4-0.3-0.9-0.4-1.6-0.4h-2.1v3.6H-493.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-485.9,102.3h5c1.5,0,2.9,0.3,4,0.8c1.1,0.6,2,1.4,2.6,2.4c0.6,1,0.9,2.3,0.9,3.7c0,2.3-0.7,4.1-2,5.3 c-1.4,1.2-3.2,1.8-5.7,1.8h-4.9V102.3z M-480.7,113.3c1.2,0,2.1-0.4,2.8-1.1c0.6-0.7,1-1.7,1-3c0-1.1-0.3-2.1-1-2.8 s-1.5-1.1-2.7-1.1h-1.8v8H-480.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-471.9,102.3h9.9v3h-6.4v2.6h4.7v2.8h-4.7v2.6h6.4v3h-9.9V102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-460.6,102.3h6.3c1.6,0,2.9,0.4,3.8,1.2s1.4,2,1.4,3.6c0,1-0.2,1.9-0.7,2.7s-1.1,1.3-1.9,1.6l2.5,4.9 h-3.6l-2.2-4.4h-2v4.4h-3.5V102.3z M-454.9,109c0.7,0,1.3-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.4c0-0.7-0.2-1.2-0.6-1.4 c-0.4-0.3-0.9-0.4-1.6-0.4h-2.1v3.6H-454.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-597.3,126.3h2v12.3h7.1v1.7h-9.1V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-586.4,126.3h2.1v14h-2.1V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-576.5,126.3h2l5.6,14h-2.1l-1.4-3.5h-6.2l-1.4,3.5h-2.1L-576.5,126.3z M-573,135.1l-2.5-6.5l-2.5,6.5 H-573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-566.8,126.3h6.4c1.2,0,2.2,0.3,2.9,1c0.7,0.6,1,1.6,1,2.8c0,0.7-0.2,1.3-0.5,1.8 c-0.3,0.5-0.8,0.9-1.3,1.2c1.5,0.4,2.2,1.5,2.2,3.3c0,0.8-0.2,1.5-0.5,2.1c-0.4,0.6-0.8,1-1.4,1.4c-0.6,0.3-1.3,0.5-2,0.5h-6.8 V126.3z M-560.6,132.3c0.7,0,1.2-0.2,1.5-0.5c0.4-0.4,0.6-0.9,0.6-1.6c0-0.8-0.2-1.4-0.6-1.7c-0.4-0.3-0.9-0.5-1.7-0.5h-4v4.3 H-560.6z M-560.5,138.7c0.8,0,1.4-0.2,1.8-0.5c0.4-0.3,0.6-0.9,0.6-1.8s-0.2-1.4-0.6-1.8c-0.4-0.4-1.1-0.5-2-0.5h-4.1v4.6H-560.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-553.8,126.3h2.1v14h-2.1V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-549.1,126.3h2v12.3h7.1v1.7h-9.1V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-538.2,126.3h2.1v14h-2.1V126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-530,128.1h-4.3v-1.7h10.7v1.7h-4.3v12.3h-2.1V128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-517.3,135l-5.1-8.7h2.2l3.9,6.7l4-6.7h2.2l-5.1,8.7v5.3h-2V135z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M-576,32.4 c0.6-0.3,1.3-0.5,1.9-0.8c0.3-0.1,0.6-0.3,1-0.4l1-0.3c2.6-0.9,5.3-1.2,7.9-1.4c2.6,0,5.1,0.2,7.5,0.6c2.3,0.5,4.5,1.1,6.4,1.9 c1.9,0.8,3.5,1.7,4.8,2.7c1.3,1,2.3,1.9,3.1,2.8c0.8,0.9,1.4,1.6,1.8,2.1c0,0,0,0,0,0l-3.1,2.1l8.4,1.6l1.6-8.4l-3.1,2.1 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.6-1.2-1.4-2.2-2.3c-1-1-2.3-2.1-3.9-3.2c-1.6-1.1-3.6-2.1-5.8-2.9c-2.2-0.8-4.6-1.4-7.2-1.8 c-0.3-0.1-0.6-0.1-1-0.1l-0.5-0.1c-0.2,0-0.3,0-0.5,0c-0.7,0-1.4-0.1-2.1-0.1c-0.3,0-0.7,0-1-0.1c-0.3,0-0.7,0-1.1,0 c-0.7,0-1.4,0.1-2.1,0.1c-2.8,0.3-5.8,0.8-8.6,1.9l-1.1,0.4c-0.4,0.1-0.7,0.3-1,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M-592.1,45.9 c-0.3,0.6-0.5,1.3-0.8,1.9c-0.1,0.3-0.2,0.6-0.4,1l-0.2,0.5l-0.1,0.5c-0.2,0.7-0.3,1.3-0.5,1.9c-0.1,0.3-0.2,0.6-0.2,1 c0,0.3-0.1,0.6-0.1,0.9c-0.1,0.6-0.2,1.2-0.3,1.8c-0.1,0.6-0.1,1.2-0.2,1.8c-0.1,1.2-0.1,2.3,0,3.5c0.2,4.4,1.2,8,2.2,10.4 c0.5,1.2,0.9,2.1,1.2,2.7c0.3,0.6,0.5,0.9,0.5,0.9s-0.2-0.3-0.4-1c-0.3-0.6-0.7-1.6-1.1-2.8c-0.8-2.4-1.7-6-1.6-10.3 c0-1.1,0.1-2.2,0.2-3.4c0.1-0.6,0.1-1.2,0.3-1.7c0.1-0.6,0.3-1.2,0.4-1.8c0.1-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9 c0.2-0.6,0.4-1.2,0.6-1.8l0.1-0.5l0.2-0.4c0.1-0.3,0.3-0.6,0.4-0.9c0.3-0.6,0.5-1.2,0.8-1.8c0.7-1.2,1.3-2.4,2.1-3.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M-509.1,40.8 c-3.9-0.5-7.6-3.4-9.2-4.8c-0.4-0.4-1.1-0.4-1.5,0c-1.6,1.4-5.3,4.3-9.2,4.8c-0.6,0.1-1.1,0.6-1.1,1.2 c0.5,11.8,8.3,17,10.5,18.3c0.4,0.2,0.8,0.2,1.1,0c2.2-1.2,10-6.4,10.5-18.3C-508,41.4-508.5,40.9-509.1,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M-513.4,48.2 c0,3.1-2.5,5.7-5.7,5.7s-5.7-2.5-5.7-5.7c0-3.1,2.5-5.7,5.7-5.7S-513.4,45-513.4,48.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-516.5,45.2 -520,48.7 -521.7,47 -522.9,48.2 -521.2,49.9 -520,51.1 -518.8,49.9 -515.3,46.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-537,77.9c2.5-0.1,3.2-2.1,3.2-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-533.6,75.7c0,0,1,2.3,3.5,2.1c2.5-0.1,3.2-2.1,3.2-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-526.8,75.7c0,0,1,2.3,3.5,2.1c2.5-0.1,3.2-2.1,3.2-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-520,75.7c0,0,1,2.3,3.5,2.1c1-0.1,1.7-0.4,2.2-0.8"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "-537.3,67.4 -533.7,67.4 -532.5,71.4 -522.7,71.4  -521.6,67.4 -513.4,67.4 -515.9,74.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "-536.8,66.9 -536.8,63.4 -525.8,63.4 -525.8,70.9  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: -528.3,
    y1: 67.4,
    x2: -531.3,
    y2: 67.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: -528.3,
    y1: 65.4,
    x2: -529.3,
    y2: 65.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -535.6,
    y: 61.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 0.9,
    height: 1.7
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: -544.3,
    y1: 83.4,
    x2: -512.3,
    y2: 83.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: -591.3,
    y1: 83.4,
    x2: -583.3,
    y2: 83.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: -569.3,
    y1: 83.4,
    x2: -555.3,
    y2: 83.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-537.8,69.9v7.9c0,1.5-1.8,2.6-3.3,2.6h-4.5 c-0.6-2-2.1-2.5-3.8-2.5c-1.7,0-3.2,0.5-3.8,2.5h-2.6V61.5c0-1.4,1.2-3.1,2.5-3.1h4.8c2.2,0,4.6,1.5,5.7,3.4L-537.8,69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-551.2,72L-551.2,72c-0.5,0-0.9-0.4-0.9-0.9v-3 c0-0.5,0.4-0.9,0.9-0.9l0,0c0.5,0,0.9,0.4,0.9,0.9v3C-550.3,71.6-550.7,72-551.2,72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-555.8,76.4v4h-18c-0.6-2-2.1-2.5-3.8-2.5 c-1.7,0-3.2,0.5-3.8,2.5h-5.4v-4H-555.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -582.1,
    y: 67,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 10.2,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -578,
    y: 67,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 1.9,
    height: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -570.5,
    y: 67,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 10.2,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -566.4,
    y: 67,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 1.9,
    height: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -576.3,
    y: 58.1,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 10.2,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -572.2,
    y: 58.1,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 1.9,
    height: 3.1
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "-548.8,58.9 -548.8,70.4 -538.3,70.4  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-538.5,76.5h-1.9c-0.5,0-0.9-0.4-0.9-0.9l0,0 c0-0.5,0.4-0.9,0.9-0.9h1.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-578,34.4c-1.5-0.2-3.5-0.2-5.8,0l-2-8.3c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.1,0.3-0.1l3.7,1c0.1,0,0.1,0.1,0.2,0.1L-578,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-578.3,40.5l-4.2,7c0,0.1-0.1,0.1-0.2,0.1l-3.8,0.7 c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l2.7-8.1C-581.8,40.4-579.9,40.5-578.3,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-594.2,42.7C-594.2,42.6-594.2,42.6-594.2,42.7 c-0.1-0.1-0.1-0.2-0.1-0.3l1.1-3.4c0.5-1.4,0.5-3,0.2-4.5l-0.8-3.4c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1l2.3,0.1 c0.1,0,0.2,0.1,0.2,0.2l1.7,4.2c9.2-1.8,13.7-0.7,15.8,0.6c0.7,0.4,1.1,1.1,1,1.9c0,0.8-0.5,1.5-1.2,1.8 c-2.2,1.1-6.8,1.8-15.8-0.9l-2.1,4c0,0.1-0.1,0.1-0.3,0.1l-2.3-0.1C-594,42.7-594.1,42.7-594.2,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-576.6,37.3c0,0-0.1-0.1-0.1-0.2l0-1c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1c0.5,0.1,1.5,0.4,1.5,0.4 c0.1,0,0.1,0.1,0.1,0.2l0,0.7c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1l-1.5-0.1C-576.5,37.3-576.6,37.3-576.6,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-576.7,39.1c0,0-0.1-0.1-0.1-0.2l0-1c0-0.1,0.1-0.2,0.2-0.2l1.5,0.1c0.1,0,0.2,0.1,0.2,0.2l0,0.7 c0,0.1-0.1,0.2-0.2,0.2c0,0-1,0.3-1.5,0.3C-576.6,39.1-576.7,39.1-576.7,39.1C-576.7,39.1-576.7,39.1-576.7,39.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-574.9,82c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7 c0-1.5,1.2-2.7,2.7-2.7S-574.9,80.5-574.9,82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M-546.6,82c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7 c0-1.5,1.2-2.7,2.7-2.7C-547.8,79.3-546.6,80.5-546.6,82z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon-12.76185953d7d0ad0e5ac75e3212ae4672.svg";
export { ForwardRef as ReactComponent };